<template>
  <CRow>
    <CCol col="12">
      <b-card header-tag="header" header-bg-variant="dark" fluid>
        <template #header>
          <p class="mb-0" style="">
            <strong>{{ $store.state.table.namaCabang }}</strong>
          </p>
        </template>

        <CRow>
          <CCol col="12">
            <b-tabs v-model="activeTab" content-class="mt-3" align="center">
              <b-tab title="Mitra" active v-if="$store.state.role_aktif.kodeRole === 'super'">
                <Mitra :activeTab="activeTab" />
              </b-tab>
              <b-tab title="Koordinator">
                <Koordinator :activeTab="activeTab" />
              </b-tab>
              <b-tab title="Cabang">
                <Cabang :activeTab="activeTab" />
              </b-tab>
              <b-tab title="Capem">
                <Capem :activeTab="activeTab" />
              </b-tab>
            </b-tabs>
          </CCol>
        </CRow>
      </b-card>
    </CCol>
  </CRow>
</template>

<script>
import Mitra from "./mitra/mitra";
import Koordinator from "./koordinator/koordinator";
import Cabang from "./cabang/cabang";
import Capem from "./capem/capem";
export default {
  components: {
    Mitra,
    Koordinator,
    Cabang,
    Capem,
  },
  name: "mitra",
  data() {
    return {
      activeTab: 0,
    };
  },
  computed: {
    isSuper() {
      return this.$store.state.role_aktif.kodeRole == "super";
    },
  },
  mounted() {
    if (!this.isSuper) {
      console.log("not super");
      this.activeTab = 1;
    }
  },
};
</script>
